import { TypedDocumentNode, gql } from '@apollo/client';
import { FormattedDate } from 'react-intl';
import styled from 'styled-components';

import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { BodyM, BodyS } from '@sorare/core/src/atoms/typography';

import { teamPictureUrl } from 'lib/so5';

import { MainItemContent } from '../MainItemContent';
import { FixtureTimelineGame_game } from './__generated__/index.graphql';

const TeamLogo = styled.img`
  width: 20px;
`;

const Game = styled(Horizontal)`
  border-radius: var(--half-unit);
  min-height: var(--double-and-a-half-unit);
  padding: var(--half-unit) 0;
  font: var(--t-label-s);
  white-space: nowrap;
`;

const Date = styled(BodyS)`
  font-variant-numeric: tabular-nums;
`;

type Props = {
  game: FixtureTimelineGame_game | null;
};
export const FixtureTimelineGame = ({ game }: Props) => {
  if (!game?.homeTeam || !game.awayTeam) {
    return null;
  }

  const homeTeamPictureUrl = teamPictureUrl(game.homeTeam);
  const awayTeamPictureUrl = game.awayTeam
    ? teamPictureUrl(game.awayTeam)
    : null;

  return (
    <Game>
      <Date color="var(--c-neutral-700)">
        <FormattedDate value={game.date} hour="2-digit" minute="2-digit" />
      </Date>
      <MainItemContent gap={0.5}>
        <Horizontal>
          {homeTeamPictureUrl && <TeamLogo src={homeTeamPictureUrl} alt="" />}
          <BodyM>{game.homeTeam.code}</BodyM>
        </Horizontal>
        <Horizontal>
          {awayTeamPictureUrl && <TeamLogo src={awayTeamPictureUrl} alt="" />}
          <BodyM>{game.awayTeam.code}</BodyM>
        </Horizontal>
      </MainItemContent>
    </Game>
  );
};

FixtureTimelineGame.fragments = {
  game: gql`
    fragment FixtureTimelineGame_game on AnyGameInterface {
      id
      date
      homeScore
      awayScore
      awayTeam {
        slug
        code
        ...teamPictureUrl_teamInterface
      }
      homeTeam {
        slug
        code
        ...teamPictureUrl_teamInterface
      }
    }
    ${teamPictureUrl.fragments.teamInterface}
  ` as TypedDocumentNode<FixtureTimelineGame_game>,
};

export default FixtureTimelineGame;
